import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';
import { DestinatorFilter } from '../destinator-filter.model';

@Injectable()
export class MessageFilterActions {
    static getDestinatorFiltersByPersonId =
        createAction('[SubscriptionsDialog] Get Person Destinator Filters', props<{ personId: number }>());

    static getDestinatorFiltersByPersonIdSuccess =
        createAction('[SubscriptionsDialog] Get Person Destinator Filters Success',
            props<{ destinatorFilters: Array<Partial<DestinatorFilter>> }>());

    static getDestinatorFiltersByPersonIdFail =
        createAction('[SubscriptionsDialog] Get Person Destinator Filters Fail', props<{ error: any }>());

    static updateDestinatorFilters = createAction('[SubscriptionsDialog] Update Destinator filters',
        props<{ destinatorFilters: Array<Partial<DestinatorFilter>>, destinatorFilterIds: Array<number> }>());

    static updateDestinatorFiltersSuccess = createAction('[SubscriptionsDialog] Update Destinator Filters Success',
        props<{ response: any }>());

    static updateDestinatorFiltersFail = createAction('[SubscriptionsDialog] Update Destinator Filters Fail',
        props<{ error: any }>());
}
